import React from "react";
//#region types
import { SupplierFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import {
  ChartContextProvider,
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReportSearchInput,
  SearchContextProvider,
  ViewPanel,
  WidgetArea,
} from "components/common";
import SupplierList from "./supplierList";
import useSuppliersReportFilterDefinition from "./forms/useReportFilterDefinition";
import SuppliersPerMonthChart from "./widgets/suppliersByMonth";
import Top3ComparableChart from "./widgets/top3Comparable";
import { Grid } from "@mui/material";
import { useSupplierService } from "serviceHooks";
import useSupplierPermissions from "./usePermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SuppliersReport: React.FC = () => {
  const supplierService = useSupplierService();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useSuppliersReportFilterDefinition();
  const title = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.Suppliers);

  const { canViewSuppliers } = useSupplierPermissions();

  const topRightButtons = (
    <DashboardButtonGroup
      buttons={[
        <ReportSearchInput
          placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.Search)}
        />,
        ACTION_SEPARATOR,
        <FilterButton />,
      ]}
    />
  );

  return (
    <SearchContextProvider>
      <PageLayouts.DashboardLayout<SupplierFormTypes.Filter>
        entityKey={0}
        hasPermissions={canViewSuppliers}
        title={title}
        topRightButtons={topRightButtons}
        filterFields={reportFilterDefinition}
        filterQueryStateHandler={filterQueryStateHandler}
        apiToReportFilterFormatter={apiToReportFilterFormatter}
        reportToAPIFilterFormatter={supplierService.reportToAPIFilter}
        filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Supplier}
      >
        <WidgetArea>
          <ChartContextProvider>
            <ViewPanel
              title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.SuppliersPerMonth)}
              appearance="sm"
              gridSize="md"
              isCanvasContent
            >
              <SuppliersPerMonthChart />
            </ViewPanel>
          </ChartContextProvider>

          <ViewPanel
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Supplier.Top3MonthlyCost)}
            appearance="sm"
            gridSize="md"
            isCanvasContent
          >
            <Top3ComparableChart />
          </ViewPanel>
        </WidgetArea>
        <Grid container item>
          <SupplierList />
        </Grid>
      </PageLayouts.DashboardLayout>
    </SearchContextProvider>
  );
};

export default SuppliersReport;
